import { useInternalChromeConfigContext } from 'src/providers/InternalChromeConfigContextProvider';
import useIsFeatureEnabled from 'src/commons/hooks/useIsFeatureEnabled';
import { WeblabedFeatures } from 'src/commons/constants';
import { logger } from 'src/commons/utils/logger';
import { shouldUpdateLinks } from './shouldUpdateLinks';
import { getUpdatedUrl } from './urlUpdateUtils';

/**
 * Returns a URL transform function when link updating is active for the
 * current application, or undefined when updating does not apply.
 *
 * Requires the url update weblab to be enabled.
 *
 * The returned function accepts a URL string and returns either the updated
 * URL or the original URL unchanged (if no update rule matches).
 */
export const useLinkUpdater = (): ((url: string) => string) | undefined => {
  const { config: internalChromeConfig } = useInternalChromeConfigContext();
  const appName = internalChromeConfig.applicationName;
  const isUrlUpdateFeatureEnabled = useIsFeatureEnabled(
    WeblabedFeatures.LEGACY_CONVERSION_METRICS_URL_REWRITE_ANDON_CORD,
  );

  if (!isUrlUpdateFeatureEnabled) {
    logger.info('useLinkUpdater: disabled, url update weblab not enabled');
    return undefined;
  }
  if (!shouldUpdateLinks(appName)) return undefined;

  return (url: string): string =>
    getUpdatedUrl(url, window.location.href, internalChromeConfig);
};
